var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_2",
    d: "M8.13517 7.20416C7.84734 6.91632 7.38066 6.91632 7.09283 7.20416C6.80499 7.49199 6.80499 7.95866 7.09283 8.2465L11.3491 12.5027L7.09287 16.759C6.80504 17.0468 6.80504 17.5135 7.09287 17.8013C7.38071 18.0891 7.84738 18.0891 8.13521 17.8013L12.3914 13.5451L16.6476 17.8013C16.9355 18.0891 17.4021 18.0891 17.69 17.8013C17.9778 17.5135 17.9778 17.0468 17.69 16.759L13.4338 12.5027L17.69 8.2465C17.9778 7.95866 17.9778 7.49199 17.69 7.20416C17.4022 6.91632 16.9355 6.91632 16.6477 7.20416L12.3914 11.4604L8.13517 7.20416Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.92d52befa4f38a0a52179a385e99bed2.svg";
export { ForwardRef as ReactComponent };